import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { business, images } from '../data/business';
const navItems = [{
  to: '/',
  label: 'Home'
}, {
  to: '/over-ons',
  label: 'Over ons'
}, {
  to: '/diensten',
  label: 'Gordijnrails'
}, {
  to: '/resources',
  label: 'Resources'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-40 border-b border-line bg-white/95 backdrop-blur" data-id="element-85" data-mp="31bp1azyekw9v">
      <div className="hidden border-b border-line bg-ink text-white lg:block" data-id="element-86" data-mp="36bl5az73onpf">
        <div className="mx-auto flex max-w-shell items-center justify-between px-6 py-2 text-[13px]" data-id="element-87" data-mp="3ba4wbe0jwpon">
          <p className="text-white/70" data-id="element-88" data-mp="3fbq5ao9ysjtk">
            Gordijnrailsystemen voor architecten, interieurontwerpers en projectpartners — sinds {business.since}
          </p>
          <div className="flex items-center gap-6" data-id="element-89" data-mp="2wm5ompcqaiva">
            <a className="transition-colors hover:text-accent" href={`tel:${business.phoneLink}`} data-id="element-90" data-mp="2rli1wfvj8o6v">
              {business.phoneDisplay}
            </a>
            <a className="transition-colors hover:text-accent" href={`mailto:${business.email}`} data-id="element-91" data-mp="2mordn59kqmad">
              {business.email}
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-shell items-center justify-between gap-6 px-6 py-4" data-id="element-92" data-mp="3fakgtfys82xo">
        <Link to="/" className="flex items-center gap-3" aria-label="Goelst International B.V. — naar de homepage" data-id="element-93" data-mp="3acr9ukpnn4wc">
          <img src={images.logo} alt="Logo van Goelst International B.V. — European Quality & Design" className="h-9 w-auto" width={160} height={36} data-id="element-94" data-mp="35jg28hd0qk3d" />
        </Link>

        <nav aria-label="Hoofdnavigatie" className="hidden items-center gap-1 lg:flex" data-id="element-95" data-mp="3talj8zup3if9">
          {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `rounded-sm px-3 py-2 text-[15px] font-medium transition-colors ${isActive ? 'text-accent' : 'text-ink-soft hover:text-ink'}`} data-id="element-96" data-mp="1rew56a91kdng">
              {item.label}
            </NavLink>)}
        </nav>

        <div className="hidden lg:block" data-id="element-97" data-mp="18pg3vkpj8h5z">
          <a href={`tel:${business.phoneLink}`} className="inline-flex items-center gap-2 bg-accent px-5 py-3 text-[15px] font-semibold text-white transition-colors hover:bg-accent-dark" data-id="element-98" data-mp="1cox8yd11rcam">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-99" data-mp="13os5uf2vz029" />
            Bel ons
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobiel-menu" className="inline-flex items-center gap-2 border border-line px-3 py-2 text-sm font-semibold text-ink lg:hidden" data-id="element-100" data-mp="2t3q5hw550b2a">
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-101" data-mp="hh4pbypxkqqu" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-102" data-mp="w47som0xptm3" />}
          Menu
        </button>
      </div>

      {open && <div id="mobiel-menu" className="border-t border-line bg-white lg:hidden" data-id="element-103" data-mp="rcpyqhxbwtam">
          <nav aria-label="Mobiele navigatie" className="mx-auto flex max-w-shell flex-col px-6 py-2" data-id="element-104" data-mp="154mle6g8aazm">
            {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `border-b border-line py-3 text-[15px] font-medium ${isActive ? 'text-accent' : 'text-ink'}`} data-id="element-105" data-mp="105tbeo05h247">
                {item.label}
              </NavLink>)}
            <div className="flex flex-col gap-3 py-4" data-id="element-106" data-mp="3bwx836zanawn">
              <a href={`tel:${business.phoneLink}`} className="bg-accent px-5 py-3 text-center text-[15px] font-semibold text-white" data-id="element-107" data-mp="22ynkzkxoqtdr">
                {business.phoneDisplay}
              </a>
              <a href={`mailto:${business.email}`} className="border border-ink px-5 py-3 text-center text-[15px] font-semibold text-ink" data-id="element-108" data-mp="2cxwbg3tcdpvd">
                E-mail ons
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}